import React, { useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { useMediaQuery } from 'react-responsive'
import { reduxForm, Field, reset } from "redux-form";

import { sendRegisterNowCredentials } from "../../store/actions";
import PlaceholderImage from "../../sharedComponents/placeholderImage";
import Logo from "../../assets/images/logo-color.png";
import { FormField } from "../../sharedComponents/formField";
import { registerFormFieldList } from "../../constants/session";
import { NotificationManager } from "react-notifications";
import "./Session.scss";

const RegisterNow = ({ history, handleSubmit, sendRegisterNowCredentials }) => {
	const [submitting, setSubmitting] = useState(false);
	const [errors, setErrors] = useState({})

	const isDesktop = useMediaQuery({ query: '(min-width: 992px)' });

	const submitRegister = (values) => {
		setSubmitting(true);
		setErrors({});
		const successHandler = (event) => {
			NotificationManager.success("Registration Successfull!", "", 5000);
			history.push("/signin");
		};

		const errorHandler = (event) => {
			if (event && event.error_code === "VALIDATION_ERROR") {
				const errors = event.errors || [];
				let data = "";
				setErrors(errors);
				Object.keys(errors).map(key => {
					const obj = registerFormFieldList.filter(item => key === item.name) || { label: "" };
					return data = `${data} ${obj[0].label}: ${errors[key].toString()} \n`;
				})

				NotificationManager.error(`${data}`, "", 10000);
			}
		};
		sendRegisterNowCredentials(values, successHandler, errorHandler);
	};
	return (
		<section className="page page-session">
			<div className="session-wrap">
				{isDesktop ? (
					<div className="session-left">
						<div className="left-data-container">
							<h2 className="normal">How do I register?</h2>
							<p>
								Membership to our Signature Patient Website is free for active patients of any of our 91 weight loss
								clinic locations nation-wide.
							</p>
							<ul className="check-list">
								<li>
									Enter the unique 10 digit registration code on the bottom of a recent receipt. You can enter it
									in any format. The dashes do not matter.
								</li>
								<li>Enter your email address. You will use this email address to log in.</li>
								<li>Create your password by entering it twice.</li>
							</ul>
							<p>
								It&apos;s that easy! Once registered, you can log in at any time using your email address and
								password.
							</p>
						</div>
					</div>) : null}
				<div className="session-right">
					<PlaceholderImage src={Logo} />
					<h3 className="text-center text-primary-dark mt-4 mb-3">
						Account Registration.
					</h3>
					<form className="m-0" onSubmit={handleSubmit(submitRegister)}>
						{registerFormFieldList &&
							registerFormFieldList.length > 0 &&
							registerFormFieldList.map(({ type, name, label, validate, options }, index) => {
								return (
									<Field
										key={index}
										label={label}
										name={name}
										type={type}
										formGroupClass={"no-label mt-4"}
										responseError={errors[name]}
										component={FormField}
										validate={validate}
										options={options}
										onChange={() => setSubmitting(false)}
									/>
								);
							})}
						<button
							type="submit"
							disabled={submitting}
							className="w-100 mt-2 btn btn-primary btn-lg text-uppercase">
							Submit
						</button>
						<div className="text-right mt-2 mb-5">
							<Link to="/signin" className="text-secondary">
								Login
							</Link>
						</div>
					</form>
				</div>
			</div>
		</section>
	);
};

const mapDispatchToProps = {
	resetForm: reset,
	sendRegisterNowCredentials
};

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "RegisterNowForm"
	})(RegisterNow)
);
